
import {Component, Vue} from "vue-property-decorator";

@Component({})
export default class PreviewKeys extends Vue {

    private currentKeys: any = [];
    private keysInRelay: any = [];
    private relayId: number = null;
    private buildingId: number = null;
    private boxId: number = null;
    private headers: object[] = [];
    private search: string = "";
    private saving: boolean = false;
    private legendDialog: boolean = false;
    private availableLocationsCount: number = 0;
    private noAvailableLocationsDialog: boolean = false;

    get correctKeys(): any[] {
        return this.currentKeys?.filter((k) => (k?.currentValues?.name || k?.currentValues?.parent)) || [];
    }
    get newKeysInRelay() {
        return this.correctKeys?.filter((k) => k?.currentValues?.status === "IN_RELAY") || [];
    }
    private mounted() {
        this.headers = [
            {value: "fileLine", text: this.$tc("box.lines", 1), sortable: false},
            {value: "informations", sortable: false},
            {value: "status", sortable: false},
            {value: "category", text: this.$t("category.category"), sortable: true},
            {value: "name", text: this.$t("key.name"), sortable: true},
            {value: "parent", text: this.$t("key.keyParent"), sortable: true},
            {value: "buildingName", text: this.$t("import.keys.columns.buildingName"), sortable: true},
            {value: "buildingId", text: this.$t("import.keys.columns.buildingId"), sortable: true},
            {value: "description", text: this.$t("key.description"), sortable: true},
            {value: "keysTags", text: this.$t("tags.tag"), sortable: false},
            {value: "boxIdImport", text: this.$t("import.keys.columns.boxId"), sortable: false},
            {value: "keyManagers", text: this.$tc("key.keyManagers", null), sortable: false},
        ];
        this.reset();
    }
    private reset(): void {
        if (!this.$route.params?.items?.length || !this.$route.params?.relayId) {
            this.$router.push({name: "keys"});
            return;
        }
        this.currentKeys = JSON.parse(JSON.stringify(this.$route.params.items || {}));
        this.relayId = parseInt(this.$route.params.relayId, 10);
        this.buildingId = parseInt(this.$route.params.buildingId, 10);
        this.boxId = parseInt(this.$route.params.boxId, 10);
        this.currentKeys.forEach((key) => {
            key.currentValues.relayId = this.relayId;
        });
        const putKeysInRelay = this.$route.params.putKeysInRelay === "true";
        if (putKeysInRelay || this.boxId) {
          this.keysInRelay = this.currentKeys;
        }
    }

    private searchCurrentValues(value, search, item) {
        return (
            item?.currentValues?.name?.toLowerCase().includes(search.toLowerCase())
            || item?.currentValues?.description?.toLowerCase().includes(search)
            || item?.currentValues?.keyManagers?.reduce((a, c) => a + c.email, "")?.toLowerCase().includes(search)
        );
    }

    private getChipColor(item: any, entityControl?: any): string {
        if (item.duplicate || item.duplicatedLine || (!item.currentValues.name && !item.currentValues.parent)) {
            return "grey";
        } else if (entityControl && !(entityControl?.check || entityControl?.id)) {
            return "red";
        } else {
            return "default";
        }
    }

    private getChipTextColor(item: any, manager?: any): string {
        if (item.duplicate || item.duplicatedLine || (!item.currentValues.name && !item.currentValues.parent)) {
            return "grey";
        } else if (!manager?.id && item.importId === undefined) {
            return "red";
        } else {
            return "default";
        }
    }

    private deleteKey(key): void {
        if (confirm(this.$t("key.deleteImportKeyConfirmation").toString())) {
            const pos = this.currentKeys.map((k) => k.importId).indexOf(key.importId);
            this.currentKeys.splice(pos, 1);
        }
    }

    private removeManager(key, manager): void {
        if (confirm(this.$t("user.deleteConfirmation").toString())) {
            const pos = key.currentValues.keyManagers.map((m) => m.email).indexOf(manager.email);
            key.currentValues.keyManagers.splice(pos, 1);
        }
    }
    private removeTag(key, tag): void {
        if (confirm(this.$t("tags.deleteConfirmation").toString())) {
            const pos = key.currentValues.keysTags.map((m) => m.name).indexOf(tag.name);
            key.currentValues.keysTags.splice(pos, 1);
        }
    }

    private async importKeys(): Promise<any> {
        this.currentKeys.forEach((key) => {
            key.currentValues.relayId = this.relayId;
            key.currentValues.boxId = this.boxId;
            key.currentValues.status = this.keysInRelay.map((k) => k.importId).includes(key.importId)
                ? "IN_RELAY"
                : "CREATED";
        });
        this.saving = true;
        if (this.newKeysInRelay?.length) {
            let availableLocations;
            if (this.boxId) {
              availableLocations = await this.$store.dispatch("boxes/getAvailableLocations", {
                boxId: this.boxId,
              });
            } else {
              availableLocations = await this.$store.dispatch("buildings/getAvailableLocations", {
                buildingId: this.buildingId,
              });
            }
            this.availableLocationsCount = availableLocations.count;
        }
        if (!this.correctKeys?.length) {
            return this.$router.push({name: "keys"});
        }
        if (this.newKeysInRelay.length <= this.availableLocationsCount) {
            this.$store.dispatch("keys/import", {
                keys: this.correctKeys,
            }).then((data) => {
                this.$router.push({
                    name: data.keyLocations?.length
                        ? "key-locations"
                        : "keys",
                    params: {data},
                });
            }).catch((err) => {
                const error: string = err.response?.data?.error || err.response?.data?.message || "error";
                this.saving = false;
                const splitError: string[] = error.split("--");
                this.$store.commit("alerts/displayError", {
                    msg: splitError.length > 1
                        ? this.$t("import.keys." + splitError[0], {
                                name : splitError[1],
                                line: splitError[2],
                            })
                        : this.$t("import.keys." + error),
                });
            });
        } else {
            this.saving = false;
            this.noAvailableLocationsDialog = true;
        }
    }

    private close() {
        this.legendDialog = false;
    }
}
